import gql from "graphql-tag";

// Staff props
const HeatlStaffProps = gql`
    fragment HeatlStaffProps on Staff {
        id
        surname
        first_name
        middle_name
        designation {
            id
            name
        }
    }
`;

const HealthBloodProps = gql`
    fragment HealthBloodProps on HealthBlood {
        id
        comment
        author {
            ...HeatlStaffProps
        }
        created_at
        resultGroups
        attachment
        takenBy
        dateOfResult
    }
    ${HeatlStaffProps}
`;

const LIST = gql`
    query GetHealthBloods($id: ID!) {
        GetHealthBloodAssessments(id: $id) {
            docs {
                ...HealthBloodProps
            }
        }
    }
    ${HealthBloodProps}
`;

const CREATE = gql`
    mutation NewHealthBlood($model: InputHealthBlood!) {
        StartHealthBloodAssessment(model: $model) {
            message
            doc {
                ...HealthBloodProps
            }
        }
    }
    ${HealthBloodProps}
`;

const UPDATE = gql`
    mutation UpdateHealthBlood($id: ID!, $comment: String!) {
        UpdateHealthBlood(id: $id, comment: $comment) {
            message
            doc {
                ...HealthBloodProps
            }
        }
    }
    ${HealthBloodProps}
`;

export { LIST, CREATE, UPDATE };
